import vSelect from 'vue-select'
import JsonExcel from 'vue-json-excel'
import Loading from './components/Loading.vue'
import Container from './components/Container.vue'
import Collapse from './components/Collapse.vue'
import FormInput from './components/Form/Input.vue'
import FormTextarea from './components/Form/Textarea.vue'
import FormFile from './components/Form/File.vue'
import FormSelect from './components/Form/Select.vue'
import FormSelectTable from './components/Form/SelectTable.vue'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
	Vue.component('loading', Loading)
	Vue.component('container', Container)
	Vue.component('collapse', Collapse)
	Vue.component('form-input', FormInput)
	Vue.component('form-textarea', FormTextarea)
	Vue.component('form-file', FormFile)
	Vue.component('form-select', FormSelect)
	Vue.component('form-select-table', FormSelectTable)
	Vue.component('downloadExcel', JsonExcel)
	Vue.component('v-select', vSelect)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js